
import {
  ChangeDetectorRef,
  Component,
  importProvidersFrom,
  ViewChild,
} from "@angular/core";
import { SharedModule } from "../../../../shared/shared.module";
import { NxDialogService, NxModalRef } from "@aposin/ng-aquila/modal";
import { PdpaPopupComponent } from "../../../../popup/pdpa-popup/pdpa-popup.component";
import { ActivatedRoute, Router } from '@angular/router';
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { Select, Store } from "@ngxs/store";
import { SatMotorState } from "@store/sat-motor/sat-motor.state";
import { UserResponse } from "@interfaces/user";
import { RESET_MOTOR_STATE, SET_CURRENT_STEP, STORE_AGENT_ADDITIONAL } from "@store/sat-motor/sat-motor.action";

@Component({
  selector: 'app-agent-additional-info',
  standalone: true,
  imports: [SharedModule],
  templateUrl: './agent-additional-info.component.html',
  styleUrl: './agent-additional-info.component.scss'
})
export class AgentAdditionalInfoComponent {

  
  @Select(SatMotorState.motorAgentAdditionalDetail) agentAdditionalDetail$;

  userInfo: any;

  agentData: any;
  customerType: any;
  isBACustomer: Boolean = false;
  isFranchiseCustomer: Boolean = false;
  isBancaUser: Boolean = false;
  isSundriesUser: Boolean = false;
  commonLov: any;
  isSingleAgent: boolean = false;

  bankList: any[] = [];
  bankChannels: any[] = [];
  bankSubChannels: any[] = [];
  bankBranches: any[] = [];
  salesCampaigns: any[] = [];
  bankClientTypes: any[] = [];

  selectedBankChannel: any;
  selectedBankSubChannel: any
  additionalInfoForm: any;

  isRequote: boolean = false;
  isDraftRecord: boolean = false;
  isDataFromView: boolean = false;

  constructor(
    private dialogService: NxDialogService,
    private cdr: ChangeDetectorRef,
    private router: Router,
    public store: Store,
  ) {
    this.userInfo = this.store.selectSnapshot<UserResponse>(state => state.UserState.user);
    this.commonLov = this.store.selectSnapshot<any>(state => state.SatMotorState?.lov);
    this.agentData = this.store.selectSnapshot(SatMotorState.motorAgentDetail);
    this.isRequote = this.store.selectSnapshot<any>((state) => state.SatMotorState.requoteQuotation);
    this.isDraftRecord = this.store.selectSnapshot<any>((state) => state.SatMotorState.draftDetails);
    this.isDataFromView = this.store.selectSnapshot<any>((state) => state.SatMotorState.viewQuotation || state.SatMotorState.updateQuotation);

    if(this.agentData) {
      this.setUserTypes(this.agentData);
      this.bankChannels = this.agentData.bankChannels;
      if (this.agentData.bankClientTypes) {
        this.bankClientTypes = this.agentData.bankClientTypes.map(client => ({
          ...client,
          descp: client.descp.toUpperCase()
        }));
      }
    }
  }

  setBankList() {
    let latestAgentData = this.store.selectSnapshot<any>((state) => state.SatMotorState.motor.step1.agentDetail ?? null);
    let bankType = latestAgentData?.bankType ?? null;
    if (bankType) {
      this.bankList = [
        {
          code: bankType,
          descp: bankType
        }
      ];
    }
    
    if (this.bankList) {
      this.additionalInfoForm.controls['bankType'].setValue(bankType);
    }
  }

  setUserTypes(data: any) {
    if (data.customerType) {
      this.isBACustomer = data.customerType === 'BA';
      this.isFranchiseCustomer = data.customerType === 'FR';
      this.customerType = this.isBACustomer ? "BANCASSURANCE" : "FRANCHISE & OTHERS";
    } else {
      this.isBancaUser = data.bancaAgent;
      this.isSundriesUser = data.sundriesAgent;
    }

    if ((this.isBACustomer || this.isFranchiseCustomer) && data.sundriesAgent) { //AGIC-49325
      let latestAgentData = this.store.selectSnapshot<any>((state) => state.SatMotorState.motor.step1.agentDetail ?? null);
      let bankType = latestAgentData?.bankType ?? null;

      if (!bankType || bankType == '') {
        this.isBACustomer = false;
        this.isFranchiseCustomer = false;
        this.isSundriesUser = true;
      }
    }

    this.setFormStructure();
  }

  setFormStructure() {
    if (this.isBACustomer) {
      this.additionalInfoForm = new FormGroup({
        bankType: new FormControl('', Validators.required),
        bankChannel: new FormControl('', Validators.required),
        bankSubChannel: new FormControl('', Validators.required),
        bankBranch: new FormControl('', Validators.required)
      });
    } else if (this.isFranchiseCustomer) {
      this.additionalInfoForm = new FormGroup({
      });
    
    } else if (this.isBancaUser) {
      this.additionalInfoForm = new FormGroup({
        bankType: new FormControl('', Validators.required),
        bankChannel: new FormControl('', Validators.required),
        bankSubChannel: new FormControl('', Validators.required),
        bankBranch: new FormControl('', Validators.required),
        bankStaffNo: new FormControl(''),
        bankStaffName: new FormControl(''),
        referralSalesStaffId: new FormControl(''),
        referralSalesStaffName: new FormControl(''),
        bankClientType: new FormControl('', Validators.required),
        salesCampaign: new FormControl(''),
        rebateType: new FormControl('')
      });
    
    } else if (this.isSundriesUser) {
      this.additionalInfoForm = new FormGroup({
        rebateType: new FormControl('', Validators.required)
      });
    }
  }

  ngOnInit() {
    window.scroll({ top: 0, left: 0, behavior: 'instant' });
    this.setStep();
    this.isSingleAgent = this.store.selectSnapshot<any>((state) => state.SatMotorState.isSingleAgent);
    if(this.isBancaUser || this.isBACustomer) {
      this.setBankList();
    }
    this.agentAdditionalDetail$.subscribe((state) => {
      if (state) {
        this.populateFormFields(state);
      }
    });
  }

  setStep() {
    let step;
    {
      step = 1;
      this.store.dispatch(new SET_CURRENT_STEP(step));
    }
  }

  populateFormFields(state: any) {
    if (this.isBACustomer) {
      this.additionalInfoForm.controls?.bankType?.setValue(state.bankType);
      this.additionalInfoForm.controls?.bankChannel?.setValue(state.bankChannel);
      this.onBankChannelChange(state.bankChannel);
      this.additionalInfoForm.controls?.bankSubChannel?.setValue(state.bankSubChannel);
      this.onBankSubChannelChange(state.bankSubChannel);
      this.additionalInfoForm.controls?.bankBranch?.setValue(state.bankBranch);
    
    } else if (this.isFranchiseCustomer) {
    
    } else if (this.isBancaUser) {
      this.additionalInfoForm.controls?.bankType?.setValue(state.bankType);
      this.additionalInfoForm.controls?.bankChannel?.setValue(state.bankChannel);
      this.onBankChannelChange(state.bankChannel);
      this.additionalInfoForm.controls?.bankSubChannel?.setValue(state.bankSubChannel);
      this.onBankSubChannelChange(state.bankSubChannel);
      this.additionalInfoForm.controls?.bankBranch?.setValue(state.bankBranch);

      this.additionalInfoForm.controls?.bankStaffNo?.setValue(state.bankStaffNo);
      this.additionalInfoForm.controls?.bankStaffName?.setValue(state.bankStaffName);
      this.additionalInfoForm.controls?.referralSalesStaffId?.setValue(state.referralSalesStaffId);
      this.additionalInfoForm.controls?.referralSalesStaffName?.setValue(state.referralSalesStaffName);

      this.additionalInfoForm.controls?.salesCampaign?.setValue(state.salesCampaign);
      this.additionalInfoForm.controls?.bankClientType?.setValue(state.bankClientType);
    
    } else if (this.isSundriesUser) {
      this.additionalInfoForm.controls?.rebateType?.setValue(state.rebateType);
    }
  }

  onBankChannelChange(code: string) {
    const selectedChannel = this.bankChannels.find(channel => channel.code === code);
    if (selectedChannel) {
      this.bankSubChannels = selectedChannel.subList || [];
      this.bankBranches = [];
      this.salesCampaigns = [];
      this.additionalInfoForm.controls?.bankSubChannel?.setValue('');
      this.additionalInfoForm.controls?.bankBranch?.setValue('');
      this.additionalInfoForm.controls?.salesCampaign?.setValue('');
    }
  }

  onBankSubChannelChange(code: string) {
    const selectedSubChannel = this.bankSubChannels.find(subChannel => subChannel.code === code);
    if (selectedSubChannel) {
      this.bankBranches = selectedSubChannel.subList || [];
      this.salesCampaigns = selectedSubChannel.salesCampaignList || [];
      this.additionalInfoForm.controls?.bankBranch?.setValue('');
      this.additionalInfoForm.controls?.salesCampaign?.setValue('');
    }
  }

  goToSelectAgentCode() {
    console.log('goToSelectAgentCode..');
    this.store.dispatch(new RESET_MOTOR_STATE()).subscribe((state) => { 
      this.store.dispatch(new STORE_AGENT_ADDITIONAL(null)).subscribe(() => {
        this.router.navigate(['agent-selection'], {
          queryParamsHandling: 'preserve',
          });
      });
    });
  }

  goNext() {
    let agentAdditionalData = this.additionalInfoForm.getRawValue();
    this.store.dispatch(new STORE_AGENT_ADDITIONAL(agentAdditionalData)).subscribe(() => {
      this.router.navigate(['issuance/declaration-issuance-info'], {
        queryParamsHandling: 'preserve',
      });
    });

  }

  isAgentDisabled() {
    if (this.isRequote || this.isDraftRecord || this.isDataFromView) {
      return true;
    }
    else {
      return false;
    }
  }

}
